import { render, staticRenderFns } from "./mproduct.vue?vue&type=template&id=05ca94b0&scoped=true&"
import script from "./mproduct.vue?vue&type=script&lang=js&"
export * from "./mproduct.vue?vue&type=script&lang=js&"
import style0 from "./mproduct.vue?vue&type=style&index=0&id=05ca94b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca94b0",
  null
  
)

export default component.exports